import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { GetMyLicensesService, GetAutodeskLetter } from '../../services/ProfileService';
import Str from '../common/Str';
import SkeletonContainer, { getSkeletonHeight } from '../../loaders/SekletonContainer';
import moment from 'moment';
import { BASE_URL, UPLOAD_ROOT_PATH } from '../../utils/Constants';
import Swal from 'sweetalert2';
import { LabelMedium } from '../common/GlobalElements/Typography';
import { StandardButton } from '../common/GlobalElements/StandardButton';
import { ContainerWrapper } from '../common/GlobalElements/Wrappers';
import { normalizeActionColumns } from '../../utils/tableColumns';

const Licenses = (props) => {
    const [licenses, setLicenses] = useState([]);
    const [search, setSearch] = useState('');
    const [renderTable, setRenderTable] = useState(true);
    const [loading, setLoading] = useState(false);
    const [canGetAutodesk, setCanGetAutodesk] = useState(false);
    const [refresh, setRefresh] = useState(false);
    useEffect(() => {
        setRenderTable(false);
        GetMyLicensesService()
            .then((res) => {
                setLicenses(res.data?.licenses_data || []);
                setCanGetAutodesk(res.data?.canGetAutodesk ? true : false);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setRenderTable(true);
            });
    }, [refresh]);

    const handleRequestAutodesk = () => {
        setLoading(true);
        GetAutodeskLetter()
            .then((res) => {
                if (res.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Autodesk Letter Generated',
                        text: 'Your Autodesk verification letter has been generated successfully.',
                    });
                    setRefresh((prev) => !prev);
                }
            })
            .catch((err) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Could not generate Autodesk Eligibility Letter',
                    text: err?.response?.data?.message || 'Error generating document',
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const columns = [
        {
            name: 'Name',
            selector: 'file_name',
            sortable: true,
        },
        {
            name: 'Date Generated',
            selector: 'date_generated',
            sortable: true,
            cell: (row) => (row?.date_generated ? moment.unix(row?.date_generated).format('DD MMM YYYY hh:mm a') : '-'),
        },
        {
            name: 'Action',
            selector: 'action',
            cell: (row) => (
                <div className="assessment-08 advSearch-action-con">
                    <div className="as-buttons">
                        <StandardButton
                            as="a"
                            href={BASE_URL + (row?.path).replace(UPLOAD_ROOT_PATH, '').replace('public', '')}
                            target="_blank"
                            rel="noopener noreferrer"
                            isRounded={true}
                            title="Download"
                        >
                            <i className="fal fa-download"></i>
                        </StandardButton>
                    </div>
                </div>
            ),
        },
    ];

    const resetFilter = () => {
        setSearch('');
    };

    const handleSearchFilter = (e) => {
        setSearch(e.target.value);
    };

    const dataToRender = () => {
        if (!search) return licenses;

        return licenses.filter((item) => item?.file_name?.toLowerCase()?.includes(search.toLowerCase()));
    };

    return (
        <ContainerWrapper variant="outline" className="custom-table-div filter-search-icon card card-table-custom">
            <div className="search-filter-div">
                <div className="search-filter-div-left">
                    <div className="system-administration-table table-responsive">
                        <div className="table-responsive-div">
                            <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                <div id="assessment-table-main_filter" className="dataTables_filter">
                                    <LabelMedium for="filterDataTable" className="icon"></LabelMedium>
                                    <input
                                        type="text"
                                        name="filterDataTable"
                                        className="filter-text"
                                        placeholder="Search"
                                        onChange={handleSearchFilter}
                                        value={search}
                                    />
                                    <div className="filter-eff filter-data-btn">
                                        <span className="filter-buttons">
                                            <i className="fal fa-filter"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filter-button-group">
                            <div className="reset-btn-group">
                                <div className="button-reset">
                                    <StandardButton onClick={resetFilter} title="Reset">
                                        <i className="fal fa-redo"></i>Reset
                                    </StandardButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="search-filter-div-right">
                    <div className="filter-search-bar-blk">
                        <div className="add-ticket-blk button-reset">
                            {canGetAutodesk ? (
                                <StandardButton
                                    variant="primary"
                                    disabled={loading}
                                    title="Request Autodesk Eligibility Letter"
                                    onClick={() => {
                                        handleRequestAutodesk();
                                    }}
                                >
                                    {loading ? (
                                        <i className="fas fa-cog fa-spin"></i>
                                    ) : (
                                        <i className="fal fa-file-invoice"></i>
                                    )}{' '}
                                    Request Autodesk Eligibility Letter
                                </StandardButton>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <DataTable
                columns={normalizeActionColumns(columns)}
                data={dataToRender()}
                progressPending={!renderTable}
                pagination={true}
                defaultSortField="license_type"
                defaultSortAsc={false}
                highlightOnHover={false}
                progressComponent={<SkeletonContainer height={getSkeletonHeight(10)} />}
                noDataComponent={Str.noRecord}
            />
        </ContainerWrapper>
    );
};

export default Licenses;
